import { ErrorMessage, ErrorMessageProps } from '@acceso/design-system';
import { useRouteError } from 'react-router-dom';

import i18n from '@/i18n/config';

import { routerManager } from '../app-routes';
import { MediaManagerRouteEnum } from '../constants/MediaManagerRouteEnum';
import { RouteException } from '../RouteExceptions/RouteException';

const defaultError: ErrorMessageProps = {
  title: 'Error al cargar la página',
  description: 'No podemos cargar la página. Comprueba tu conexión',
  onClick: () => {
    routerManager.to({
      name: MediaManagerRouteEnum.MEDIA_MANAGER,
      replace: true,
    });
  },
  textButton: i18n.t('Volver'),
};

export const ErrorBoundary = () => {
  const error = useRouteError();
  const isControlled = error instanceof RouteException;

  const errorMessageProps: ErrorMessageProps = {
    ...defaultError,
    ...(isControlled && {
      type: error.errorType,
      title: error.title,
      description: error.description,
      onClick: () => {
        routerManager.goBack();
      },
    }),
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <ErrorMessage {...errorMessageProps} />
    </div>
  );
};
